import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';

import { BLACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

const labelSx = {
  color: BLACK[70],
  display: 'block',
  fontFamily: PRIMARY_FONT[500],
  fontSize: '11px',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
};

const FieldLabel = ({ children, htmlFor, sx }) => (
  <Typography
    component={htmlFor ? 'label' : 'p'}
    htmlFor={htmlFor}
    sx={sx ? [labelSx, sx] : labelSx}
  >
    {children}
  </Typography>
);

FieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string,
  sx: PropTypes.shape({}),
};

export default FieldLabel;
